import axios from 'axios';

export class RequestFellowship {
  static preEntryChie = async (
    name,
    email,
    country,
    jpnLevel,
    experience,
    tool,
    lessonTime,
    comment
  ) => {
    await axios.post(`fellowship/chie/pre-entry`, {
      name: name,
      email: email,
      country: country,
      jpn_level: jpnLevel,
      experience: experience,
      tool: tool,
      lesson_time: lessonTime,
      comment: comment,
    });
  };
  static preEntryMayo = async (
    name,
    email,
    jpnLevel,
    hindiLevel,
    experience,
    tool,
    lessonTime,
    comment
  ) => {
    await axios.post(`fellowship/mayo/pre-entry`, {
      name: name,
      email: email,
      jpn_level: jpnLevel,
      hindi_level: hindiLevel,
      experience: experience,
      tool: tool,
      lesson_time: lessonTime,
      comment: comment,
    });
  };
  static preEntryQuy = async (name, email, plan, lessonTime, vieLevel, comment) => {
    await axios.post(`fellowship/quy/pre-entry`, {
      name: name,
      email: email,
      plan: plan,
      lesson_time: lessonTime,
      vie_level: vieLevel,
      comment: comment,
    });
  };
  static subscribe = async (planKey, name, email, cardToken, countryCode) => {
    await axios.post(`fellowship/entry/subscribe/${planKey}`, {
      name: name,
      email: email,
      card_token: cardToken,
      country_code: countryCode,
    });
  };
}
